/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded InsertChart.
 * @export
 */
export const ICON_INSERT_CHART = (
  <svg fill="none" height="28" viewBox="0 0 28 28" width="28" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M5.83333 3.5H22.1667C23.45 3.5 24.5 4.55 24.5 5.83333V22.1667C24.5 23.45 23.45 24.5 22.1667 24.5H5.83333C4.55 24.5 3.5 23.45 3.5 22.1667V5.83333C3.5 4.55 4.55 3.5 5.83333 3.5ZM8.16667 18.6667C8.16667 19.3083 8.69167 19.8333 9.33333 19.8333C9.975 19.8333 10.5 19.3083 10.5 18.6667V12.8333C10.5 12.1917 9.975 11.6667 9.33333 11.6667C8.69167 11.6667 8.16667 12.1917 8.16667 12.8333V18.6667ZM14 19.8333C13.3583 19.8333 12.8333 19.3083 12.8333 18.6667V9.33333C12.8333 8.69167 13.3583 8.16667 14 8.16667C14.6417 8.16667 15.1667 8.69167 15.1667 9.33333V18.6667C15.1667 19.3083 14.6417 19.8333 14 19.8333ZM17.5 18.6667C17.5 19.3083 18.025 19.8333 18.6667 19.8333C19.3083 19.8333 19.8333 19.3083 19.8333 18.6667V16.3333C19.8333 15.6917 19.3083 15.1667 18.6667 15.1667C18.025 15.1667 17.5 15.6917 17.5 16.3333V18.6667Z"
      fill="#707070"
      fillRule="evenodd"
    />
  </svg>
);
